export default "__VITE_ASSET__8af87def__"